import { render, staticRenderFns } from "./select-activa.vue?vue&type=template&id=03864596&scoped=true"
import script from "./select-activa.vue?vue&type=script&lang=js"
export * from "./select-activa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03864596",
  null
  
)

export default component.exports